<template>
    <card-seplag titulo="Servidores pendentes de validação" cor="#00acc1" >  
        <table-seplag
        :dados.sync="dadosServioresPendentes"
        :totalRegistro.sync="totalRegistro"
        :campos="colunasPendenteServPublico" 
        :paginacao="true"
        :onSearchPaginacao="paginacao"
        :linhas="linha"
        cols="12" >
            <Column headerStyle="width: 9em;" class="p-grid"   v-if="ciclopessoa[0].ciclo.statCiclo == 'ABERTO'">
                <template #body="linha" >
                    <Button label="Analisar" icon="pi pi-check" class="p-button-rounded p-button-success" @click="paginaValidacao(linha.data)"/>
                </template>
            </Column>
        </table-seplag>
    </card-seplag>  
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import TableSeplag from '@/template/TableSeplag.vue'
import { baseApiUrl } from '@/config/global'
export default {
    name: "gerenciaPendente",
    components: {CardSeplag, TableSeplag},
    data: function(){        
		return {
            ciclopessoa : this.$store.getters.getCicloPessoa,
            dadosServioresPendentes:[],
            colunasPendenteServPublico : [
				{ nome: 'numrCpf', titulo: 'CPF',tamanho:'9.vw'},
				{ nome: 'nomePessoa', titulo: 'Nome'},
                { nome: 'numrMatricula', titulo: 'Matrícula',tamanho:'9.vw'},
                { nome: 'numrVinculo', titulo: 'Vínculo',tamanho:'5.vw'},
                { nome: 'descUnidade', titulo: 'Setor'}
            ],
            loadingPaginacao: true,
            totalRegistro: 0,
            linha:10,
            urlPaginacao: `vinculos/buscarVinculosPorChefia/pendentes/${this.$store.getters.getCicloPessoa[0].ciclo.idenCiclo}/${this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula}`
            //${this.$store.getters.getCicloPessoa[0].vinculosAtivos[0].numrMatricula}`
		}
    },     
    methods: {
        async carregarDados(){   
            if(this.$store.getters.getCicloPessoa){          
                await this.paginacao();
            }else{
                this.$router.push({name:"recadastramento"})
            }
        },
        paginaValidacao(dados){
            this.$store.commit("setServSelecionado",dados)
            this.$router.push({name:'CHEFIAGERENCIA_VALIDACOES'})
        },        
        paginacao(rows=10,page=0){
            this.$http.get(`${baseApiUrl}/${this.urlPaginacao}?size=${rows}&page=${page}`).then(res =>{
                    this.dadosServioresPendentes = res.data.content
                    this.totalRegistro = res.data.totalElements
                    this.linha = rows
            }) 
        }
    },
    mounted(){
        this.carregarDados()
    }

}
</script>